import _ from "lodash";
import BigNumber from "bignumber.js";
import { formatDecimalStatic } from "@/help/decimalStatic";

// возвращаем цену токена в базовой валюте (defaultTokenMnemonic)
export function getPrice(owner, currencySup) {
  let currencyToken = owner?.rateDefaultToken;
  let amount = currencySup.getBalance(owner?.auToken?.id);

  let price = BigNumber(currencyToken).multipliedBy(owner?.amount);

  price = price
    .dividedBy(BigNumber(10).pow(owner?.auToken?.decimals))
    .toNumber();

  const mainTokenPrice = BigNumber(amount)
    .dividedBy(BigNumber(10).pow(owner?.auToken?.decimals))
    .toFixed(owner?.auToken?.indent);

  return {
    mainTokenPrice: Number(mainTokenPrice),
    tokenPrice: isNaN(price) ? 0 : price
  };
}

// возвращаем цену токена в базовой валюте использую поле rateDefaultToken (defaultTokenMnemonic)
export function getPriceNew(owner, currencySup) {
  let currencyToken = Number(isNaN(owner?.rateDefaultToken) ? 0 : Number((owner?.rateDefaultToken)));
  let amount = currencySup.getBalance(owner?.auToken?.id);
  let priceAmount = BigNumber(currencyToken).multipliedBy(owner?.amount);
  let priceUSD = BigNumber(currencyToken).multipliedBy(owner?.amount);
  let reserved = BigNumber(currencyToken).multipliedBy(
    BigNumber(owner?.amountBlocked?.replace(/\s/g, "") || "0")
  );

  priceAmount = priceAmount
    .dividedBy(BigNumber(10).pow(owner?.auToken?.decimals))
    .toNumber();

  priceUSD = priceUSD
    .dividedBy(BigNumber(10).pow(owner?.auToken?.decimals))
    .toNumber();

  reserved = reserved
    .dividedBy(BigNumber(10).pow(owner?.auToken?.decimals))
    .toNumber();

  const mainTokenPrice = BigNumber(amount)
    .dividedBy(BigNumber(10).pow(owner?.auToken?.decimals))
    .toFixed(owner?.auToken?.indent);

  return {
    mainTokenPrice: Number(mainTokenPrice), // все балансы токенов для графика
    tokenPrice: isNaN(priceAmount) ? 0 : priceAmount,
    tokenPriceUSD: isNaN(priceUSD) ? 0 : priceUSD,
    reserved: isNaN(reserved) ? 0 : reserved
  };
}

// объединяет основные балансы с ордерами (stacking + projects) myProjectsOrders
export function splitBalance(value, myStackingOrders, myProjectsOrders) {
  const newStackingOrdersArr = _.map(myStackingOrders, (item) => ({
    amount: item?.valueAbsolute,
    auToken: {
      decimals: item.tokenQuote.decimals,
      id: item.tokenQuote.id,
      indent: item.tokenQuote.indent,
      type: item.tokenQuote.type
    }
  }));

  const newProjectsOrdersArr = _.map(myProjectsOrders, (item) => ({
    amount: item.sum,
    auToken: {
      decimals: item.tokenQuote.decimals,
      id: item.tokenQuote.id,
      indent: item.tokenQuote.indent,
      type: item.tokenQuote.type
    }
  }));

  return [...value, ...newStackingOrdersArr, ...newProjectsOrdersArr];
}

// рассчитывает fullSum, series, mappedSeries для графика
export function usersBalances(value, currencySup) {
  const series = [];
  const mappedSeries = [];
  const mappedSeriesUSD = [];
  const reservedValues = [];

  _.forEach(value, (owner) => {
    const { reserved, tokenPrice, tokenPriceUSD } = getPriceNew(owner, currencySup);
    const isFloor = Math.floor(tokenPrice) === tokenPrice;
    const isFloorUSD = Math.floor(tokenPriceUSD) === tokenPriceUSD;
    const finalPrice = isFloor ? Math.floor(tokenPrice) : tokenPrice;
    const finalPriceUSD = isFloorUSD ? Math.floor(tokenPriceUSD) : tokenPriceUSD;

    series.push({ id: owner?.auToken?.id, price: finalPrice });
    mappedSeries.push(finalPrice);
    mappedSeriesUSD.push(finalPriceUSD);
    reservedValues.push(reserved);
  });

  const balance = _.sum(mappedSeries);
  const balanceUSD = _.sum(mappedSeriesUSD);
  const fullAssets = balance;

  const reserve = _.sum(reservedValues);
  const assetsReserved = reserve;

  const fullAssetsSum = parseFloat(fullAssets) - parseFloat(assetsReserved);

  return {
    series,
    mappedSeries,
    assetsReserved,
    fullAssetsSum,
    balance,
    balanceUSD
  };
}

export function getSumInvest(arrayInvestProject, defaultTokenDecimals = 2) {
  const newArrayInvestProject = _.map(arrayInvestProject, (item) => ({
    amount: item.sum,
    auToken: {
      decimals: item.tokenQuote.decimals,
      id: item.tokenQuote.id,
      indent: item.tokenQuote.indent,
      type: item.tokenQuote.type
    }
  }));

  const result = newArrayInvestProject.map(item => {
    const amount = new BigNumber(item.amount);
    const processedAmount = amount.dividedBy(BigNumber(10).pow(defaultTokenDecimals)).toNumber();
    return processedAmount;
  });

  const totalSum = _.sum(result);
  return String(totalSum);
}

export function getSumStacking(arrayStackingProject) {
  const newArrayStackingProject = _.map(arrayStackingProject, (item) => ({
    amount: item?.valueAbsolute,
    auToken: {
      decimals: item.tokenQuote.decimals,
      id: item.tokenQuote.id,
      indent: item.tokenQuote.indent,
      type: item.tokenQuote.type
    }
  }));

  const result = newArrayStackingProject.map(item => {
    const amount = new BigNumber(item.amount);
    const processedAmount = amount.dividedBy(BigNumber(10).pow(item?.auToken?.decimals)).toNumber();
    return processedAmount;
  });

  const totalSum = _.sum(result);
  return String(totalSum);
}

// Получаем баланс и инвестиции из daily запроса
export function getDalyBalanceInvest(array, defaultTokenDecimals = 2) {
  const firstElement = array[0];

  const sumInvest = formatDecimalStatic({
    value: firstElement?.activeOrders,
    decimal: defaultTokenDecimals
  }).replace(/\s/g, "");

  const sumBalance = formatDecimalStatic({
    value: firstElement?.briefcaseValue,
    decimal: defaultTokenDecimals
  }).replace(/\s/g, "");

  return {
    rawInvest: firstElement?.activeOrders,
    rawBalance: firstElement?.briefcaseValue,
    sumInvest,
    sumBalance
  };
}